/**
 * Avatar-lettres d'un membre : initiales et couleur DÉTERMINISTE (hash de
 * l'identifiant → teinte stable entre rendus et entre écrans). Partagé par la
 * pile d'avatars des listes (variante `solid`) et les cartes collaborateur
 * (variante `soft`, lettre foncée sur fond pastel) — même teinte pour un même
 * compte dans les deux rendus.
 */

const PALETTE: { solid: string; soft: string }[] = [
  { solid: 'bg-blue-500 text-white', soft: 'bg-blue-100 text-blue-700' },
  { solid: 'bg-green-500 text-white', soft: 'bg-green-100 text-green-700' },
  { solid: 'bg-purple-500 text-white', soft: 'bg-purple-100 text-purple-700' },
  { solid: 'bg-orange-500 text-white', soft: 'bg-orange-100 text-orange-700' },
  { solid: 'bg-pink-500 text-white', soft: 'bg-pink-100 text-pink-700' },
  { solid: 'bg-teal-500 text-white', soft: 'bg-teal-100 text-teal-700' },
  { solid: 'bg-indigo-500 text-white', soft: 'bg-indigo-100 text-indigo-700' },
  { solid: 'bg-red-500 text-white', soft: 'bg-red-100 text-red-700' },
];

export const avatarClasses = (id: string, variant: 'solid' | 'soft' = 'solid'): string => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length][variant];
};

/** Initiales depuis prénom/nom, avec repli sur l'email puis « ? ». */
export const avatarInitials = (
  firstName?: string | null,
  lastName?: string | null,
  email?: string | null,
): string => {
  const f = (firstName ?? '').trim();
  const l = (lastName ?? '').trim();
  if (f || l) {
    return `${f.charAt(0)}${l.charAt(0)}`.toUpperCase() || '?';
  }
  const mail = (email ?? '').trim();
  return mail ? mail.charAt(0).toUpperCase() : '?';
};

/** Initiales depuis un nom d'affichage complet (deux premiers mots). */
export const avatarInitialsFromDisplayName = (
  displayName?: string | null,
  email?: string | null,
): string => {
  const words = (displayName ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length > 0) {
    return words
      .slice(0, 2)
      .map((w) => w.charAt(0))
      .join('')
      .toUpperCase();
  }
  const mail = (email ?? '').trim();
  return mail ? mail.charAt(0).toUpperCase() : '?';
};
